import React, {Component} from 'react'
import {
    NavBar,
    Icon,
    List,
    Toast,
    WhiteSpace,
    SearchBar,
    ActionSheet,
    Modal
  } from 'antd-mobile'
import './groupPrefixList.scss'
import axios from "../../../service/axios";
import NoneDatas from "../../../components/noneDatas";
const Item = List.Item;
const Brief = Item.Brief;

export class groupPrefixList extends Component {
  state = {
    pageNo: 1,
    pageTotalNum: 0,
    prefixDatas: [],
    // getICCID: '11111222223333344445',
    // getICCID: '8986032141200194311',
    getICCID:'',
    name:''
  }
  componentWillMount(){
    this.getPrefixListDatas()
  }
  // 获取前缀列表
  getPrefixListDatas(){
    axios.post('/api/group/prefixname/list',{
      prefixName:this.state.name
    })
      .then( res => {
        if(res && res.status === 200){
          if(res.data.length!=0){
            console.log("res",res)
            this.setState({
              prefixDatas: res.data
            })
          }
          else{
            this.setState({
              prefixDatas: []
            })
            Toast.fail('暂无数据!');
          }
        }else{
          console.log("res",res)
          Toast.fail(res.message);
        }
      })
  }
  // 点击前缀列表唤起动作面板
  showActionSheet(item){
    // const BUTTONS = ['扫码进群', '修改', '详情', '删除', '取消'];
    const BUTTONS = ['修改', '详情', '删除', '取消'];
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      cancelButtonIndex: BUTTONS.length - 1,
      destructiveButtonIndex: BUTTONS.length - 2,
      message: '操作"'+item.prefixName+'"',
      maskClosable: false,
      'data-seed': 'logId',
    },
    (buttonIndex) => {
      console.log(buttonIndex)
      if(buttonIndex==0){
        // 调用微信扫码
        // this.DYcamera(item.prefixName)

        // 修改前缀信息
        this.props.history.push('/editGroupPrefix?'+item.prefixName)
      }
      else if(buttonIndex==1){
        // 查看详情页面
        this.props.history.push('/groupPrefixDetails?'+item.prefixName)
      }
      else if(buttonIndex==2){
        // 删除前缀群组
        Modal.alert('提示', '确定删除"'+item.prefixName+'"前缀吗?', [
          { text: '取消', onPress: () => console.log('cancel') },
          {
            text: '确定',
            onPress: () =>
              this.delete(item.prefixName)
          },
        ])
      }
    });
  }
  //删除列表前缀
  delete(prefixName){
    axios.post('api/group/prefixname/delete',{
      prefixName
    })
    .then(res=>{
      if(res.status==200){
        Toast.success('删除成功!',1)
        setTimeout(() => {
          this.getPrefixListDatas();
        }, 1000);
      }
      else{
        Toast.fail(res.message,1)
      }
      console.log(res)
    })
  }
  // 查询前缀
  submit(val){
    this.setState({
      name:val
    },()=>{
      this.getPrefixListDatas()
    })
  }
  // 微信扫码
  DYcamera = (prefixName) => {
    window.wx.scanQRCode({
      needResult: 1,
      desc: "scanQRCode desc",
      success: (res) => {
        if(res.resultStr.indexOf(',')!=-1){
          var result =  res.resultStr.split(',')[1];
          this.setState({
            getICCID: result
          },()=>{
            this.checkIccid(prefixName)
          })
        }
        else{
          this.setState({
            getICCID: res.resultStr
          },()=>{
            this.checkIccid(prefixName)
          })
        }
      }
    })
  }
  checkIccid(prefixName){
    axios.post('/api/group/prefixname/members/iccid',{
      iccid:this.state.getICCID
    })
    .then(res=>{
      console.log(res)
      if(res.status == 200){
        console.log(res)
        this.props.history.push(`/prefixInfo/${prefixName}/${this.state.getICCID}`)
      } else {
        Toast.fail(res.message,1)
      }
    })
  }

  
  render() {
    const {
      pageNo,
      pageTotalNum,
      prefixDatas,
      getICCID,
    } = this.state 

    
    return (
      <div className='groupPrefixList'>
        <div className="header-sticky">
            <NavBar
              icon={<Icon type="left" />}
              onLeftClick={() => this.props.history.goBack()}
              rightContent={[
                <div key='1'>
                    <span
                        key='1'
                        onClick={()=>{
                            this.props.history.push('/addGroupPrefix')
                        }}
                        style={{ fontSize: '14px',color:'#fff',marginRight:'4px' }}
                    >添加</span>
                </div>
              ]}
          >
            前缀列表
          </NavBar>
          <SearchBar
            onSubmit={value => this.submit(value)}
            placeholder="输入前缀查询" 
            />
        </div>
        <div className='prefixList'>
          <span>
            <Item><Brief>点击群组前缀进行操作!</Brief></Item>
          </span>

          {prefixDatas.length == 0 ? <NoneDatas/>:null}
          {prefixDatas.map((item,index)=> {
            return (
              <div key={index}>
                <List>
                  <Item
                    key={index}
                    arrow="horizontal"
                    onClick={() => {
                      this.showActionSheet(item)
                      // 调取微信扫码
                      // this.DYcamera(item.prefixName)
                      // 判断扫描结果的iccid在平台有绑定账号
                      // this.checkIccid(`/prefixInfo/${item.prefixName}/${getICCID}`)
                      
                    }}
                  >
                    {item.prefixName}
                  </Item>
              </List>
              </div>
            )
          })}
          <WhiteSpace />
          {/* 没有分页 */}
        </div>
        
      </div>
    )
  }
}

export default groupPrefixList

